import makeStyles from '@mui/styles/makeStyles';
import { greys } from '../../../../styling/theme';
import {
  NAV_RECON_POSITION_DETAIL_COLUMN_WIDTHS,
  NAV_RECON_POSITION_DETAIL_TABLE_WIDTH,
} from './navReconPositionsColumns';

const DETAIL_TABLE_CELL_PADDING_Y = '0.25rem';
const DETAIL_TABLE_CELL_PADDING_X = '0.25rem';

const detailTableCellPadding = {
  padding: `${DETAIL_TABLE_CELL_PADDING_Y} ${DETAIL_TABLE_CELL_PADDING_X} !important`,
  paddingTop: `${DETAIL_TABLE_CELL_PADDING_Y} !important`,
  paddingBottom: `${DETAIL_TABLE_CELL_PADDING_Y} !important`,
  paddingLeft: `${DETAIL_TABLE_CELL_PADDING_X} !important`,
  paddingRight: `${DETAIL_TABLE_CELL_PADDING_X} !important`,
};

const buildColumnWidthRules = () => {
  const rules: Record<string, object> = {};
  NAV_RECON_POSITION_DETAIL_COLUMN_WIDTHS.forEach((width, index) => {
    const nth = index + 1;
    const isNameColumn = index === 0;
    // `&&` doubles the root class so these per-column widths beat the parent
    // positions table's leaked `:first-of-type` rule (which otherwise squashes
    // this nested table's Name column to the parent's 3rem expand-column width).
    rules[
      `&& .MuiTableHead-root .MuiTableRow-root > .MuiTableCell-root:nth-of-type(${nth}), && .MuiTableBody-root .MuiTableRow-root > .MuiTableCell-root:nth-of-type(${nth})`
    ] = {
      width: `${width} !important`,
      minWidth: `${width} !important`,
      maxWidth: `${width} !important`,
      ...(isNameColumn
        ? {
            whiteSpace: 'normal !important',
            wordBreak: 'break-word !important',
            overflow: 'visible !important',
          }
        : {}),
    };
  });
  return rules;
};

export const useNavReconPositionDetailTableStyles = makeStyles(() => ({
  detailContent: {
    margin: 0,
    padding: '0.75rem 1rem',
    border: `1px solid ${greys.grey200}`,
    overflowX: 'auto',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  detailTableRoot: {
    overflow: 'visible !important',
    width: 'max-content !important',
    minWidth: '100%',
    '& .MuiTable-root': {
      width: `${NAV_RECON_POSITION_DETAIL_TABLE_WIDTH} !important`,
      minWidth: `${NAV_RECON_POSITION_DETAIL_TABLE_WIDTH} !important`,
      tableLayout: 'fixed !important',
    },
    '&& .MuiTableHead-root .MuiTableCell-root': {
      whiteSpace: 'normal !important',
      wordBreak: 'break-word !important',
      lineHeight: 1.25,
      verticalAlign: 'bottom',
      ...detailTableCellPadding,
    },
    '& .MuiTableCell-root': {
      overflow: 'hidden',
      verticalAlign: 'top',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      boxSizing: 'border-box',
      ...detailTableCellPadding,
    },
    ...buildColumnWidthRules(),
  },
}));
